import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import ViewWork from '@Components/ViewWork'
import SongwriterSearchedWorkHeader from '@Scenes/SongwriterScene/SongwriterViewSearchedWorkScene/SongwriterSearchedWorkHeader'

const SongwriterViewSearchedWorkScene = () => {
    const { publicViewWorkStore } = useContext(StoresContext)
    return (
        <>
            <title>View Work</title>
            {publicViewWorkStore.viewWorkPublic && (
                <div className="view-work-songwriter-searched-scene">
                    <SongwriterSearchedWorkHeader work={publicViewWorkStore.viewWorkPublic} />
                    <ViewWork viewWork={publicViewWorkStore.viewWorkPublic} showMatchedRecordings workType="work" />
                </div>
            )}
        </>
    )
}

export default observer(SongwriterViewSearchedWorkScene)
